import React from "react";
import Chart from "react-apexcharts";

const ApexChart = ({ data, categories, title }) => {
  const series = [
    {
      name: "",
      data: [10, 20],
    },
  ];
  const options = {
    chart: {
      height: 400,
      type: "line",
    },
    stroke: {
      width: 7,
      curve: "smooth",
    },
    xaxis: {
      type: "datetime",
      categories: categories ? categories : [""],
      tickAmount: 10,
    },
    title: {
      text: title,
      align: "left",
      style: {
        fontSize: "16px",
        color: "#666",
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        gradientToColors: ["#FDD835"],
        shadeIntensity: 1,
        type: "horizontal",
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100, 100, 100],
      },
    },
    markers: {
      size: 4,
      colors: ["#FFA41B"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    yaxis: {
      // min: -10,
      // max: 40,
      title: {
        text: "Utterances",
      },
    },
  };

  return (
    <div>
      <Chart
        options={options}
        series={data ? data : series}
        type="line"
        height={400}
      />
    </div>
  );
};

export default ApexChart;
